/** Trip status labels — aligned with admin Trip History. */
export const TRIP_STATUS_LABELS = {
  0: "Pending",
  1: "Ongoing",
  2: "Locked",
  3: "Completed",
  4: "Cancelled",
};

export const TRIP_STATUS_FILTER_OPTIONS = [
  { key: "", label: "All Types", status: null },
  { key: "pending", label: "Pending", status: "0" },
  { key: "ongoing", label: "Ongoing", status: "1" },
  { key: "locked", label: "Locked", status: "2" },
  { key: "completed", label: "Completed", status: "3" },
  { key: "cancelled", label: "Cancelled", status: "4" },
];

/**
 * @param {number|string|{ status?: number|string, trip_status?: string }|null|undefined} input
 */
export function tripStatusLabel(input) {
  if (input != null && typeof input === "object") {
    if (typeof input.trip_status === "string" && input.trip_status.trim()) {
      return input.trip_status.trim();
    }
    return tripStatusLabel(input.status);
  }

  if (typeof input === "string" && input.trim() && Number.isNaN(Number(input))) {
    return input.trim();
  }

  const n = Number(input);
  if (Object.prototype.hasOwnProperty.call(TRIP_STATUS_LABELS, n)) {
    return TRIP_STATUS_LABELS[n];
  }

  if (input != null && input !== "") return String(input);
  return "—";
}
